export default {"src":"/_next/static/media/cor6.46ffea9d.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};